import * as api from '../contactApi';
import {
  call,
  put,
  select,
  takeEvery
  } from 'redux-saga/effects';
import { contactActionCreators, ContactActionKeys, DeactivateContact } from '..';
import { IState } from '../..';
import { uiActionCreators } from '../../ui';

function* deactivateContactSaga(action: DeactivateContact) {
  yield put(uiActionCreators.showSpinnerDialog());
  yield call(api.deactivateContact, action.payload);
  const contact = yield select((state: IState) => state.contacts.hash[action.payload.contactId]);

  if (contact) {
    yield put(contactActionCreators.processContacts([{ ...contact, inactive: true }]));
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeactivateContact() {
  yield takeEvery(ContactActionKeys.DEACTIVATE_CONTACT, deactivateContactSaga);
}
